import { render, staticRenderFns } from "./RetailFMCGSolution.vue?vue&type=template&id=7b7996b6&"
import script from "./RetailFMCGSolution.vue?vue&type=script&lang=js&"
export * from "./RetailFMCGSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports